export const SAVE_PLAYER_COMPLETE_REQUEST = 'SAVE_PLAYER_COMPLETE_REQUEST';
export const SAVE_PLAYER_COMPLETE_SUCCESS = 'SAVE_PLAYER_COMPLETE_SUCCESS';
export const SAVE_PLAYER_COMPLETE_ERROR = 'SAVE_PLAYER_COMPLETE_ERROR';





